import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.vip20.loaded,
    (loaded) => {
        return {
            loaded
        }
    }
)